import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier, GoogleAuthProvider, FacebookAuthProvider, signInWithPopup } from 'firebase/auth';

const firebaseConfig = {
  // These values come directly from your Firebase web app config panel
  apiKey: 'AIzaSyCuWwzmrOOOjY7BH-PTfbTuK8uChRpsYrI',
  authDomain: 'swarna-setu.firebaseapp.com',
  projectId: 'swarna-setu',
  storageBucket: 'swarna-setu.firebasestorage.app',
  messagingSenderId: '138161392848',
  appId: '1:138161392848:web:c9b161c3a37b3b51e2e2d5',
  measurementId: 'G-2LT0F35CKF',
};

let app;

// Initialize Firebase app safely (avoid re-initialization in HMR/dev)
if (!getApps().length) {
  try {
    app = initializeApp(firebaseConfig);
  } catch (err) {
    console.error('[FirebaseClient] Failed to initialize Firebase app:', err?.message || err);
    throw err;
  }
} else {
  app = getApp();
}

const auth = getAuth(app);
auth.useDeviceLanguage();

// Social auth providers
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

let recaptchaVerifier = null;

/**
 * Lazily create and cache an invisible reCAPTCHA verifier.
 * The DOM must contain an element with the given containerId.
 */
export const getRecaptchaVerifier = (containerId = 'recaptcha-container') => {
  if (recaptchaVerifier) return recaptchaVerifier;

  if (typeof window === 'undefined') {
    throw new Error('ReCAPTCHA cannot be initialized on the server');
  }

  recaptchaVerifier = new RecaptchaVerifier(auth, containerId, {
    size: 'invisible',
  });

  return recaptchaVerifier;
};

// Firebase social sign-in helpers
export const signInWithGoogle = async () => {
  const result = await signInWithPopup(auth, googleProvider);
  const idToken = await result.user.getIdToken();
  return { user: result.user, idToken };
};

export const signInWithFacebook = async () => {
  const result = await signInWithPopup(auth, facebookProvider);
  const idToken = await result.user.getIdToken();
  return { user: result.user, idToken };
};

export { app, auth };
